<template>
  <div class="container">
    <div class="fixed">
      <b-tabs class="tab_bar container" v-model="tabIndex" fill>
        <b-tab :title="$t('community.all')" active title-link-class="tab_text tab"></b-tab>
        <b-tab :title="$t('community.notice')"  title-link-class="tab_text tab"></b-tab>
        <b-tab :title="$t('community.find_site')"  title-link-class="tab_text tab" ></b-tab>
        <b-tab :title="$t('community.worker_job')"  title-link-class="tab_text tab"></b-tab>
        <b-tab :title="$t('community.report')"  title-link-class="tab_text tab" ></b-tab>
      </b-tabs>
    </div>
    <div class="container-content-with-search">
      <CommunityItem
        v-for="(item, i) in dataList"
        :key="i"
        :item="item"
        :currentTab="currentTab"
        variant="user"
        @click="onDetail(item)"
      >
      </CommunityItem>
    </div>
    <Navbar>
      <SearchForm
                  variant="user"
                  :searchValue.sync="keyword"
                  :searchType.sync="searchType"
                  :mine.sync="mine"
                  :count="pageCnt"
                  @change_page="change_page"
                  @search="type_search"
                  @make="onCreate"
      ></SearchForm>
    </Navbar>
    <CommunityDetailPopup
      :visible.sync="showDetail"
      :info="communitySelected"
      :onDelete="onDeleteItem"
      @edit="onEditItem"
    >
    </CommunityDetailPopup>
    <CommunityCreatePopup
      :visible.sync="showCreate"
      :info="communitySelected"
      :onEdit="onEdit"
    >
    </CommunityCreatePopup>
  </div>
</template>

<script>
import Utils from "../../../../config/utils";
import Navbar from "../../../controls/navbar";
import SearchForm from "../admin/controls/search_form";
import CommunityDetailPopup from "../../../controls/popup/CommunityDetailPopup";
import CommunityCreatePopup from "../../../controls/popup/CommunityCreatePopup";
import CommunityItem from "../../../controls/CommunityItem";

export default {
  name: "Community",
  components: {
    SearchForm,
    Navbar,
    CommunityDetailPopup,
    CommunityCreatePopup,
    CommunityItem
  },
  data() {
    return {
      tabIndex:0,
      dataList:[],
      pageCnt:1,
      totalCnt:1,
      limit:0,
      mine:false,
      searchType:null,
      keyword:null,
      currentPage:1,
      communitySelected:null,
      showDetail:false,
      showCreate:false,
    }
  },
  methods:{
    onDetail(item){
      this.communitySelected = item;
      this.showDetail = true;
    },
    onCreate() {
      this.communitySelected = null;
      this.showCreate = true;
    },
    onDeleteItem(){
      Utils.toast(this, this.$t('common.delete_success'));
      this.showDetail = false;
      this.dataList = this.dataList.filter(it => {
        return it.f_idx != this.communitySelected.f_idx;
      });
    },

    onEditItem(){
      this.showDetail=false;
      setTimeout(()=>{
        this.showCreate=true;
      },10);
    },

    onEdit(){
      this.getList();
    },

    change_page(page){
      this.currentPage = page;
      this.getList();
    },

    type_search(){
      this.getList();
    },

    getList(){
      if (this.$store.getters.isLoading) {
        return;
      }

      Utils.requestGet(this.$c.API.Community.getCommunityList, {
        page_num: this.currentPage,
        type: this.currentTab,
        column: this.searchType,
        keyword: this.searchType == 'f_contact' ? this.keyword.replaceAll('-', '') : this.keyword,
        mine: this.mine ? 1 : 0
      }).then((result) => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.totalCnt  = result.data.total;
            this.pageCnt = result.data.page_count;
            this.limit = result.data.limit;
            this.dataList = result.data.list;
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
  },

  computed:{
    currentTab(){
      switch (this.tabIndex){
        case 0: return null;
        case 1: return 'N';
        case 2: return 'S';
        case 3: return 'W';
        case 4: return 'R';
      }
      return null;
    }
  },
  watch:{
    tabIndex(){
      //request code here!
      this.getList();
    },
    mine(){
      this.getList();
    }
  },

  mounted() {
    this.$store.commit('setTabIndex', this.$c.MAIN_TAB.COMMUNITY);
    this.getList();
  }
}
</script>

<style lang="scss">
@import '../../../../assets/css/_vars.scss';
</style>



// WEBPACK FOOTER //
// src/components/contents/main/community/Community.vue